/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.4.0 (NJsonSchema v9.10.46.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import {Injectable, Inject, Optional, InjectionToken} from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class ApiServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return OK
     */
    swagger(): Observable<any> {
        let url_ = this.baseUrl + "/api/Swagger";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwagger(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwagger(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processSwagger(response: Response): Observable<any> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }
}

@Injectable()
export class VideoServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @catId (optional)
     * @return OK
     */
    videos(pageNo: number, pageSize: number, catId: number): Observable<ResultOfListOfVideoDto> {
        let url_ = this.baseUrl + "/video/videos?";
        if (pageNo === undefined || pageNo === null)
            throw new Error("The parameter 'pageNo' must be defined and cannot be null.");
        else
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (catId !== undefined)
            url_ += "catId=" + encodeURIComponent("" + catId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVideos(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVideos(<any>response_);
                } catch (e) {
                    return <Observable<ResultOfListOfVideoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResultOfListOfVideoDto>><any>Observable.throw(response_);
        });
    }

    protected processVideos(response: Response): Observable<ResultOfListOfVideoDto> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResultOfListOfVideoDto.fromJS(resultData200) : new ResultOfListOfVideoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResultOfListOfVideoDto>(<any>null);
    }

    /**
     * @return OK
     */
    videoCategoryInfo(pId: number): Observable<VideoCategoryInfoDto[]> {
        let url_ = this.baseUrl + "/video/videoCategoryInfo?";
        if (pId === undefined || pId === null)
            throw new Error("The parameter 'pId' must be defined and cannot be null.");
        else
            url_ += "pId=" + encodeURIComponent("" + pId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVideoCategoryInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVideoCategoryInfo(<any>response_);
                } catch (e) {
                    return <Observable<VideoCategoryInfoDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<VideoCategoryInfoDto[]>><any>Observable.throw(response_);
        });
    }

    protected processVideoCategoryInfo(response: Response): Observable<VideoCategoryInfoDto[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(VideoCategoryInfoDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VideoCategoryInfoDto[]>(<any>null);
    }

    /**
     * @return OK
     */
    categorys(pId: number): Observable<VideoCategoryDto[]> {
        let url_ = this.baseUrl + "/video/categorys?";
        if (pId === undefined || pId === null)
            throw new Error("The parameter 'pId' must be defined and cannot be null.");
        else
            url_ += "pId=" + encodeURIComponent("" + pId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCategorys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCategorys(<any>response_);
                } catch (e) {
                    return <Observable<VideoCategoryDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<VideoCategoryDto[]>><any>Observable.throw(response_);
        });
    }

    protected processCategorys(response: Response): Observable<VideoCategoryDto[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(VideoCategoryDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VideoCategoryDto[]>(<any>null);
    }

    /**
     * @return OK
     */
    info(id: number): Observable<VideoDto> {
        let url_ = this.baseUrl + "/video/info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processInfo(<any>response_);
                } catch (e) {
                    return <Observable<VideoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<VideoDto>><any>Observable.throw(response_);
        });
    }

    protected processInfo(response: Response): Observable<VideoDto> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VideoDto.fromJS(resultData200) : new VideoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<VideoDto>(<any>null);
    }

    /**
     * @return OK
     */
    addViewTimes(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/video/addViewTimes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddViewTimes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddViewTimes(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processAddViewTimes(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

export class ResultOfListOfVideoDto implements IResultOfListOfVideoDto {
    data: VideoDto[];
    totalCount: number;
    pageNo: number;
    pageSize: number;

    constructor(data?: IResultOfListOfVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Data"] && data["Data"].constructor === Array) {
                this.data = [];
                for (let item of data["Data"])
                    this.data.push(VideoDto.fromJS(item));
            }
            this.totalCount = data["TotalCount"];
            this.pageNo = data["PageNo"];
            this.pageSize = data["PageSize"];
        }
    }

    static fromJS(data: any): ResultOfListOfVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item.toJSON());
        }
        data["TotalCount"] = this.totalCount;
        data["PageNo"] = this.pageNo;
        data["PageSize"] = this.pageSize;
        return data;
    }

    clone(): ResultOfListOfVideoDto {
        const json = this.toJSON();
        let result = new ResultOfListOfVideoDto();
        result.init(json);
        return result;
    }
}

export interface IResultOfListOfVideoDto {
    data: VideoDto[];
    totalCount: number;
    pageNo: number;
    pageSize: number;
}

export class VideoDto implements IVideoDto {
    id: number;
    category_id: number;
    title: string;
    video: string;
    status: boolean;
    sort: number;
    readtimes: number;
    createdate: moment.Moment;
    cover_org: string;

    constructor(data?: IVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.category_id = data["category_id"];
            this.title = data["title"];
            this.video = data["video"];
            this.status = data["status"];
            this.sort = data["sort"];
            this.readtimes = data["readtimes"];
            this.createdate = data["createdate"] ? moment(data["createdate"].toString()) : <any>undefined;
            this.cover_org = data["cover_org"];
        }
    }

    static fromJS(data: any): VideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category_id"] = this.category_id;
        data["title"] = this.title;
        data["video"] = this.video;
        data["status"] = this.status;
        data["sort"] = this.sort;
        data["readtimes"] = this.readtimes;
        data["createdate"] = this.createdate ? this.createdate.toISOString() : <any>undefined;
        data["cover_org"] = this.cover_org;
        return data;
    }

    clone(): VideoDto {
        const json = this.toJSON();
        let result = new VideoDto();
        result.init(json);
        return result;
    }
}

export interface IVideoDto {
    id: number;
    category_id: number;
    title: string;
    video: string;
    status: boolean;
    sort: number;
    readtimes: number;
    createdate: moment.Moment;
    cover_org: string;
}

export class VideoCategoryInfoDto implements IVideoCategoryInfoDto {
    id: number;
    pid: number;
    name: string;
    icon: string;
    sort: number;
    status: boolean;
    createdate: moment.Moment;
    count: number;
    color: string;
    videos: VideoDto[];

    constructor(data?: IVideoCategoryInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.pid = data["pid"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.sort = data["sort"];
            this.status = data["status"];
            this.createdate = data["createdate"] ? moment(data["createdate"].toString()) : <any>undefined;
            this.count = data["count"];
            this.color = data["color"];
            if (data["videos"] && data["videos"].constructor === Array) {
                this.videos = [];
                for (let item of data["videos"])
                    this.videos.push(VideoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VideoCategoryInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoCategoryInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pid"] = this.pid;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sort"] = this.sort;
        data["status"] = this.status;
        data["createdate"] = this.createdate ? this.createdate.toISOString() : <any>undefined;
        data["count"] = this.count;
        data["color"] = this.color;
        if (this.videos && this.videos.constructor === Array) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }

    clone(): VideoCategoryInfoDto {
        const json = this.toJSON();
        let result = new VideoCategoryInfoDto();
        result.init(json);
        return result;
    }
}

export interface IVideoCategoryInfoDto {
    id: number;
    pid: number;
    name: string;
    icon: string;
    sort: number;
    status: boolean;
    createdate: moment.Moment;
    count: number;
    color: string;
    videos: VideoDto[];
}

export class VideoCategoryDto implements IVideoCategoryDto {
    id: number;
    pid: number;
    name: string;
    icon: string;
    sort: number;
    status: boolean;
    createdate: moment.Moment;
    cover_org: string;
    count: number;
    color: string;
    constructor(data?: IVideoCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.pid = data["pid"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.sort = data["sort"];
            this.status = data["status"];
            this.createdate = data["createdate"] ? moment(data["createdate"].toString()) : <any>undefined;
            this.cover_org = data["cover_org"];
            this.count = data["count"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): VideoCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pid"] = this.pid;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["sort"] = this.sort;
        data["status"] = this.status;
        data["createdate"] = this.createdate ? this.createdate.toISOString() : <any>undefined;
        data["cover_org"] = this.cover_org;
        data["count"] = this.count;
        data["color"] = this.color;
        return data;
    }

    clone(): VideoCategoryDto {
        const json = this.toJSON();
        let result = new VideoCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IVideoCategoryDto {
    id: number;
    pid: number;
    name: string;
    icon: string;
    sort: number;
    status: boolean;
    createdate: moment.Moment;
    cover_org: string;
    count: number;
    color: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = function() {
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob);
        }
    });
}



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts